
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var FacebookPageModel = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        FacebookPageModel = BaseModel.extend({
            name: "FacebookPageModel",
            defaults:{
                access_token: "",
                category: "",
                name: "",
                id: "",
                perms: []
            }
        });
    });

    return FacebookPageModel;
});
